import { lazy } from 'react';
import Home from './pages/Home';
import __Layout from './Layout.jsx';

// Non-home pages are lazy-loaded so they are code-split out of the main bundle,
// reducing unused JavaScript on the initial home-page load (Lighthouse perf).
// Home + Layout stay eager for fast LCP / app-shell render.
const BookingRequest = lazy(() => import('./pages/BookingRequest'));
const CameraCatalogue = lazy(() => import('./pages/CameraCatalogue'));
const SpecialOffers = lazy(() => import('./pages/SpecialOffers'));
const VideoCameraHire = lazy(() => import('./pages/VideoCameraHire'));
const VideoCameraHireLanding = lazy(() => import('./pages/VideoCameraHireLanding'));
const VideoProduction = lazy(() => import('./pages/VideoProduction'));


export const PAGES = {
    "BookingRequest": BookingRequest,
    "camera-catalogue": CameraCatalogue,
    "Home": Home,
    "SpecialOffers": SpecialOffers,
    "video-camera-and-accessory-hire": VideoCameraHire,
    "video-camera-hire": VideoCameraHireLanding,
    "video-production-services": VideoProduction,
}

export const pagesConfig = {
    mainPage: "Home",
    Pages: PAGES,
    Layout: __Layout,
};